import script from "./TokensBuy.vue?vue&type=script&setup=true&lang=js"
export * from "./TokensBuy.vue?vue&type=script&setup=true&lang=js"

import "./TokensBuy.vue?vue&type=style&index=0&id=1010e1a1&lang=scss"
import "./TokensBuy.vue?vue&type=style&index=1&id=1010e1a1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1010e1a1"]])

export default __exports__